class FaqSearch extends HTMLElement {
  constructor() {
    super()
    this.route = '/search/suggest'
    this.cachedResults = {}
    this.input = this.querySelector('.js-faq__input')
    this.faqSearchResults = this.querySelector('.js-faq__search--results')
    this.tempTotal = 0

    this.faqs = this.getSource()
    this.setupEventListeners()
  }

  getSource() {
    const source = this.getAttribute("questions-source")

    if (source === 'questionsDB') {
      return questionsDB
    } else {
      return questionsDBF
    }
  }

  setupEventListeners() {
    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event)
      }, 300).bind(this)
    )

    this.input.addEventListener('focus', this.onFocus.bind(this))
  }

  disconnectedCallback() {
    document.removeEventListener('details-closed', this.close)
  }

  getQuery() {
    return this.input.value.trim()
  }

  onChange() {
    const searchTerm = this.getQuery()

    if (!searchTerm.length) {
      this.close(true)
      return
    }

    if (searchTerm.length < 3) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  onFocus() {
    const searchTerm = this.getQuery()
    if (!searchTerm.length) return
    if (searchTerm.length < 3) return
    if (this.getAttribute('results') === 'true') {
      this.open()
    } else {
      this.getSearchResults(searchTerm)
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey])
      return
    }

    fetch(
      `${this.route}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent(
        'resources[type]'
      )}=product,article&${encodeURIComponent(
        'resources[options][fields]'
      )}=body,title,variants.barcode,variants.sku,variants.title,vendor,author&section_id=faq-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-faq-search').innerHTML

        this.cachedResults[queryKey] = resultsMarkup
        this.renderSearchResults(resultsMarkup)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  getFaqResults(items, fields) {
    const searchTerm = this.getQuery()
    if (!this.faqs.length || !searchTerm.length || searchTerm.length < 3)
      return []

    var q = new RegExp('\\b' + searchTerm + '\\b', 'ig')
    var found = items.filter(function (item) {
      var foundAny = false
      fields.forEach(function (field) {
        foundAny = foundAny || item[field].search(q) > -1
      })
      return foundAny
    })
    return found
  }

  onTabPanel(tabPanel) {
    const loadMore = tabPanel.querySelector('.load-more')
    const limit = tabPanel.dataset.limit || 0
    const step = tabPanel.dataset.step || 0
    const pageCount = Math.ceil(limit / step)

    let currentPage = 1
    currentPage = this.showItems(
      tabPanel,
      currentPage,
      limit,
      step,
      pageCount,
      loadMore
    )

    this.unsetLiveRegionLoadingState()

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        currentPage = this.showItems(
          tabPanel,
          currentPage + 1,
          limit,
          step,
          pageCount,
          loadMore
        )
      })
    }
  }

  renderFaqResults() {
    let results = ''
    let faqTab = document.getElementById('faq-search__faq-panel')

    if (faqTab) {
      let faqCounter = document.getElementById('faq-search__faq-counter')
      let faqResults = this.getFaqResults(this.faqs, ['title', 'body'])
      let faqResultsText = document.querySelector('.faq-search__result')
      let faqNoResultsText = document.querySelector('.faq-search__no-result')

      faqTab.setAttribute('data-limit', faqResults.length)
      this.tempTotal = Number(this.tempTotal) + Number(faqResults.length)

      if (faqResults.length) {

        faqResultsText.classList.remove('hidden')
        faqTab.classList.remove('hidden')
        faqNoResultsText.classList.add('hidden')

        results = faqTab.querySelector('ul')
        results.innerHTML = ''

        faqResults.forEach((question) => {
          results.innerHTML += `<li class="faq-search__item grid__item hidden">
            <div class="faq-search__wrapper">
              <h5 class="title">${question.title}</h5>
              <a class="faq-search__link js-list utility" href="#${question.id}">View</a>
            </div>
          </li>`
        })
        faqCounter.textContent = `(${faqResults.length})`
      } else {
        faqResultsText.classList.add('hidden')
        faqTab.classList.add('hidden')
        faqNoResultsText.classList.remove('hidden')
      }

      faqTab.innerHTML = ''
      if (results) {
        faqTab.appendChild(results)
      }

      if (faqResults.length) {
        results.insertAdjacentHTML(
          'afterend',
          `
            <div class="load-more__wrapper">
                <p class="counter"></p>
                <button role="button" class="load-more hidden">${__GLOBAL__.translate.general.search.load_more}</button>
            </div>
        `
        )

        this.onTabPanel(faqTab)
      }

    }

  }


  setLiveRegionLoadingState() {
    this.setAttribute('loading', true)
  }

  unsetLiveRegionLoadingState() {
    this.removeAttribute('loading')
  }

  renderSearchResults(resultsMarkup) {
    this.faqSearchResults.innerHTML = resultsMarkup
    this.setAttribute('results', true)

    this.setLiveRegionResults()
    this.open()
    this.renderFaqResults()

    this.tabPanel = this.querySelector('.faq-search__search-faq--panel')

    if (this.tabPanel && this.querySelector(".js-box")) {
      this.onTabPanel(this.tabPanel)
      this.selectField = this.querySelector(".js-box")
      this.selectList = this.querySelectorAll('.js-list')
      this.toggleList = document.querySelectorAll('.js-faq-answer-toggle')

      this.selectField.addEventListener(
        'click',
        ((event) => {
          this.currentUrl(event)
        }).bind(this)
      )
    }

  }

  currentUrl(event) {

    let urlHash = event.target.hash;
    let open = document.querySelector('.js-faq__accordion')

    open.querySelectorAll('.open').forEach((active) => {
      active.classList.remove('open')
    })

    this.close(true)

    this.toggleList.forEach((toggle) => {
      let accordionLink = toggle.hash
      if (urlHash === accordionLink) {
        if (toggle.closest('.js-faq-topic')) {
          toggle.closest('.js-faq-topic').classList.add('open')
        }
        toggle.closest('.js-faq-section').classList.add('open')
        setTimeout(() => {
          toggle.click()
        })
        toggle.parentElement.classList.add('active')
        trapFocus(toggle.parentElement, toggle)
      }
    })

  }

  setLiveRegionResults() {
    this.removeAttribute('loading')
  }

  open() {
    this.setAttribute('open', true)
    this.input.setAttribute('aria-expanded', true)
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = ''
      this.cachedResults = {}
      this.removeAttribute('results')
    }

    this.input.setAttribute('aria-activedescendant', '')
    this.removeAttribute('open')
    this.input.setAttribute('aria-expanded', false)
  }

  showItems(tabPanel, pageIndex, limit, step, pageCount, loadMore) {
    this.showLoadMore(pageCount, pageIndex, loadMore)

    const startRange = (pageIndex - 1) * step
    const endRange = pageIndex == pageCount ? limit : pageIndex * step
    const items = tabPanel.querySelectorAll('.grid__item')
    const counter = tabPanel.querySelector('.counter')

    if (items.length) {
      for (let i = startRange + 1; i <= endRange; i++) {
        if (items[i - 1]) {
          items[i - 1].classList.remove('hidden')
        }
      }
    }

    if (counter) {
      counter.textContent = `Showing ${endRange} of ${limit}`
    }

    return pageIndex
  }

  showLoadMore(pageCount, pageIndex, loadMore) {
    if (loadMore) {
      if (pageCount === pageIndex) {
        loadMore.classList.add('hidden')
      } else {
        loadMore.classList.remove('hidden')
      }
    }
  }

  debounce = (fn, wait) => {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define('faq-search', FaqSearch)
